import { Routes } from '@angular/router';
import { __importDefault } from 'tslib';
import { flowGuard, simpleFlowGuard } from './guards/flow-guard/flow-guard.guard';
import { LayoutComponent } from './components/layout/layout.component';

export const routes: Routes = [
  {
    path: ':customerId',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        loadComponent: () => import('./components/login-step/login-step.component').then((m) => m.LoginStepComponent),
      },
      {
        path: 'verify-otp',
        loadComponent: () => import('./components/verify-otp-step/verify-otp-step.component').then((m) => m.VerifyOtpStepComponent),
        canActivate: [simpleFlowGuard('verify-otp', ['login'])],
      },
      {
        path: 'application',
        loadComponent: () => import('./components/application-step/application-step.component').then((m) => m.ApplicationStepComponent),
      },
      {
        path: 'application-verify-otp',
        loadComponent: () => import('./components/application-otp-step/application-otp-step.component').then((m) => m.ApplicationOtpStepComponent),
        canActivate: [simpleFlowGuard('application-verify-otp', ['application'])],
      },
      {
        path: 'application-decision',
        loadComponent: () =>
          import('./components/application-decision-step/application-decision-step.component').then((m) => m.ApplicationDecisionStepComponent),
        canActivate: [simpleFlowGuard('application-decision', ['application', 'application-verify-otp'])],
      },
      {
        path: 'application-decision-warn',
        loadComponent: () =>
          import('./components/application-decision-warn-step/application-decision-warn-step.component').then(
            (m) => m.ApplicationDecisionWarnStepComponent,
          ),
        canActivate: [simpleFlowGuard('application-decision-warn', ['application'])],
      },
      {
        // Terminal state
        path: 'application-denial',
        loadComponent: () => import('./components/application-denial/application-denial.component').then((m) => m.ApplicationDenialComponent),
        canActivate: [simpleFlowGuard('application-denial', ['application'])],
      },
      {
        path: 'view-transaction',
        loadComponent: () => import('./components/view-transaction-step/view-transaction-step.component').then((m) => m.ViewTransactionStepComponent),
        canActivate: [
          flowGuard('view-transaction', [
            ['login', 'verify-otp'], // Login path
            ['application', 'application-decision'], // Application path
          ]),
        ],
      },
      {
        path: 'cancel',
        loadComponent: () => import('./components/cancel-step/cancel-step.component').then((m) => m.CancelStepComponent),
      },
      {
        path: 'warning',
        loadComponent: () => import('./components/warning-step/warning-step.component').then((m) => m.WarningStepComponent),
      },
    ],
  },
  {
    path: '',
    redirectTo: '/default',
    pathMatch: 'full',
  },
];
